import { render, staticRenderFns } from "./myProfileHeader.vue?vue&type=template&id=0eb54c70&scoped=true"
import script from "./myProfileHeader.vue?vue&type=script&lang=js"
export * from "./myProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./myProfileHeader.vue?vue&type=style&index=0&id=0eb54c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb54c70",
  null
  
)

export default component.exports